import { map } from 'rxjs/operators';
import { IEpic, isTypeOf } from '@cbridge-utils/redux-observable';
import { RoutingProfileAction } from '@cbridge-packages/routing-profile';

export const reloadRoutingProfileListEpic: IEpic = (action$) => action$.pipe(
  isTypeOf(
    RoutingProfileAction.create.done,
    RoutingProfileAction.update.done,
    RoutingProfileAction.remove.done,
  ),
  map(() => RoutingProfileAction.loadList.started()),
);
